<template>
  <div>
    <b-container fluid="xl">
      <b-row style="background-color: #728794; height: 55px;padding: 10px;">
        <b-col cols="1">
          <b-icon
              @click="handlePlayBtnClick"
              icon="play-circle"
              scale="2"
              aria-hidden="true"
              style="margin-right: 20px; cursor:pointer"
          />
        </b-col>
        <b-col cols="8">
          <b-card-group deck>
            <block
                v-for="(aBoardBlock, i) in lineBlocks"
                :block="aBoardBlock"
                :asset-url="assetURL"
                :is-std="false"
            />
          </b-card-group>
        </b-col>
        <b-col>
          <b-icon
              @click="handleBackBtnClick"
              icon="backspace"
              scale="2"
              aria-hidden="true"
              style="margin-right: 20px"
          />
          <b-icon
              @click="handleDeleteBtnClick"
              icon="trash"
              scale="2"
              aria-hidden="true"
              style="margin-right: 20px"
          />
        </b-col>
      </b-row>
      <b-link
          @click="handleGoBackOnBoardSchemeStack" >
        Back
      </b-link>
      <b-row>
        <block
            v-for="(aBoardBlock, i) in board"
            :block="aBoardBlock"
            :asset-url="assetURL"
            @drill-down="handleDrillDown"
            @block-click="handleBlockClick"
        />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Block from "./block";
import DefaultBoard from "../../../assets/json/defaultBoard.json";
import ResourceBlockAudio from "@/mixins/resourceBlocks/Audio";
export default {
  name: "Speak_Board",
  mixins: [ResourceBlockAudio],
  components: {
    Block
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    boardSchema: {
      type: Object,
      default: DefaultBoard
    }
  },
  created() {},
  computed: {
    board(){
      return this.activeBoardScheme && this.activeBoardScheme.blocks && Array.isArray(this.activeBoardScheme.blocks) ?
          this.activeBoardScheme.blocks: [];
    },
    canGoBack(){
      return this.boardSchemaStack > 0;
    }
  },
  methods: {
    handleAppLog(data) {
      this.$emit("appLog", data);
    },
    handleDrillDown(drillDownBoardSchema){
      this.boardSchemaStack.push(this.boardSchema);
      this.activeBoardScheme = drillDownBoardSchema;
    },
    handleGoBackOnBoardSchemeStack(){
      if (this.boardSchemaStack &&
          Array.isArray(this.boardSchemaStack) &&
          this.boardSchemaStack.length >0)
      {
        this.activeBoardScheme = this.boardSchemaStack.pop();
      }
    },
    handleBlockClick(block){
      this.lineBlocks.push(block);
    },
    handlePlayBtnClick() {
      if(Array.isArray(this.lineBlocks) && this.lineBlocks.length > 0) {
        this.playInd = 0;
        this.playList = this.lineBlocks.map(audio => audio.audioURL
        );
        this.playRepeat();
      }
    },
    handleBackBtnClick() {
      debugger
      this.lineBlocks.pop();
    },
    handleDeleteBtnClick() {
      debugger
      this.lineBlocks = [];
    }
  },
  data() {
    return {
      lineBlocks:[],
      activeBoardScheme: this.boardSchema ? this.boardSchema : {},
      boardSchemaStack:[],
      assetURL:'/assets/apps/speak/',
      DefaultBoard
    };
  }
};
</script>

<style lang="scss" scoped>
.speak-box{
  border-style: solid;
  border-color: black;
  background-color: white;
  height: 25vh;
}
</style>
